import { type FC, useCallback, useRef } from 'react';
import { useOnClickOutside, useToggle } from '@mwl/core-lib';
import { ButtonIcon } from '@/components/ButtonIcon/ButtonIcon';
import { Tooltip } from '@/components/Tooltip/Tooltip';
import type { TooltipClasses } from '@/components/Tooltip/Tooltip.types';
import { useMediaWidthDown } from '@/hooks';
import type { MarketDescriptionProps } from './MarketDescription.types';
import styles from './MarketDescription.module.scss';
const tooltipClasses: TooltipClasses = {
  content: styles.tooltipContent
};
const MarketDescription: FC<MarketDescriptionProps> = ({
  description
}) => {
  const contentRef = useRef(null);
  const [active, toggleActive] = useToggle(false);
  const isMobile = useMediaWidthDown('screenXs');
  const handleClick = useCallback(() => {
    if (isMobile) {
      toggleActive(true);
    }
  }, [isMobile, toggleActive]);
  const handleClose = useCallback(() => {
    if (isMobile) {
      toggleActive(false);
    }
  }, [isMobile, toggleActive]);
  const handleMouseEnter = useCallback(() => {
    if (!isMobile) {
      toggleActive(true);
    }
  }, [isMobile, toggleActive]);
  const handleMouseLeave = useCallback(() => {
    if (!isMobile) {
      toggleActive(false);
    }
  }, [isMobile, toggleActive]);
  useOnClickOutside(contentRef, handleClose);
  if (!description) {
    return null;
  }
  return <div className={styles.root} data-sentry-component="MarketDescription" data-sentry-source-file="MarketDescription.tsx">
      <Tooltip variant="arrow" content={<div ref={contentRef}>{description}</div>} placement="bottom" classes={tooltipClasses} visible={active} data-sentry-element="Tooltip" data-sentry-source-file="MarketDescription.tsx">
        <ButtonIcon as="button" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={handleClick} variant="text" rounded aria-label="button ?" className={styles.button} data-sentry-element="ButtonIcon" data-sentry-source-file="MarketDescription.tsx">
          ?
        </ButtonIcon>
      </Tooltip>
    </div>;
};
export { MarketDescription };